<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-document-copy"></i>
              系统日志管理
            </h1>
            <p class="page-subtitle">查看和管理系统操作日志，监控用户访问和系统行为</p>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
            <p class="search-subtitle">根据用户、时间、类型等条件筛选日志记录</p>
          </div>
          <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
            <el-form-item label="用户ID">
              <el-input 
                v-model="searchCondition.user_id" 
                placeholder="请输入用户ID" 
                clearable
                prefix-icon="el-icon-user">
              </el-input>
            </el-form-item>
            <el-form-item label="QID">
              <el-input 
                v-model="searchCondition.qid" 
                placeholder="请输入QID" 
                clearable
                prefix-icon="el-icon-key">
              </el-input>
            </el-form-item>
            <el-form-item label="访问类型">
              <el-input 
                v-model="searchCondition.channel" 
                placeholder="请输入访问类型" 
                clearable
                prefix-icon="el-icon-files">
              </el-input>
            </el-form-item>
            <el-form-item label="发布时间">
              <el-date-picker
                v-model="searchCondition.time_value"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                prefix-icon="el-icon-time">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
              <el-button @click="resetSearch" class="reset-btn">
                <i class="el-icon-refresh"></i>
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <div class="table-header">
            <div class="header-left">
              <i class="el-icon-document-copy"></i>
              <span>日志记录</span>
            </div>
            <div class="header-right">
              <el-tag type="info" size="mini">
                <i class="el-icon-info"></i>
                共 {{pagingData.total}} 条记录
              </el-tag>
            </div>
          </div>
          <ApeTable ref="apeTable" :data="sysLogList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column label="用户/访问信息" min-width="280">
              <template slot-scope="scope">
                <div class="log-info">
                  <div class="info-row">
                    <i class="el-icon-user"></i>
                    <span class="info-label">操作人：</span>
                    <el-tag size="mini" type="primary">{{scope.row.user_id}}</el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-link"></i>
                    <span class="info-label">访问地址：</span>
                    <span class="info-value url-text">{{scope.row.url}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-files"></i>
                    <span class="info-label">访问类型：</span>
                    <el-tag size="mini" type="info">{{scope.row.referer}}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="IP/时间信息" min-width="200">
              <template slot-scope="scope">
                <div class="log-info">
                  <div class="info-row">
                    <i class="el-icon-location"></i>
                    <span class="info-label">客户端IP：</span>
                    <el-tag size="mini" type="success">{{scope.row.real_ip}}</el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-time"></i>
                    <span class="info-label">访问时间：</span>
                    <span class="info-value time-text">{{scope.row.created_at}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-server"></i>
                    <span class="info-label">服务IP：</span>
                    <el-tag size="mini" type="warning">{{scope.row.server_addr}}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="请求响应信息" min-width="250">
              <template slot-scope="scope">
                <div class="log-info">
                  <div class="info-row">
                    <i class="el-icon-s-operation"></i>
                    <span class="info-label">请求方法：</span>
                    <el-tag :type="getMethodType(scope.row.method)" size="mini">{{scope.row.method}}</el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-s-data"></i>
                    <span class="info-label">请求大小：</span>
                    <span class="info-value">{{scope.row.request_body_size}} bytes</span>
                  </div>
                  <div class="info-row" v-if="scope.row.request_body">
                    <i class="el-icon-document"></i>
                    <span class="info-label">请求内容：</span>
                    <el-tooltip :content="scope.row.request_body" placement="top" :disabled="!scope.row.request_body || scope.row.request_body.length <= 30">
                      <span class="info-value body-text">{{scope.row.request_body | truncate(30)}}</span>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'

export default {
  components: {
    PageHeaderLayout,
    ApeTable
  },
  data() {
    return {
      loadingStaus: true,
      // 搜索条件
      searchCondition:{},
      // 日志列表
      sysLogList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
    }
  },
  computed: {
  },
  filters: {
    truncate(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  },
  methods: {
    // 获取请求方法类型
    getMethodType(method) {
      const methodMap = {
        'GET': 'success',
        'POST': 'primary',
        'PUT': 'warning',
        'DELETE': 'danger',
        'PATCH': 'info'
      }
      return methodMap[method] || 'info'
    },
    // 重置搜索
    resetSearch() {
      this.searchCondition = {}
      this.initSysLogList()
    },
    // 搜索
    searchButton() {
      this.initSysLogList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initSysLogList()
    },
    // 初始化附件列表
    async initSysLogList(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let  res = await this.$api.post('/service/system_operate_logs/list',searchCondition)
      if (this.$apiSuccess(res)){
        this.sysLogList = res.data.list
        this.pagingData.total = res.data.page.total
        this.loadingStaus=false
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.qid) {
        condition.qid = this.searchCondition.qid
      }
      if (this.searchCondition.channel) {
        condition.channel = this.searchCondition.channel
      }
      if (this.searchCondition.user_id) {
        condition.user_id = this.searchCondition.user_id
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }

      return condition
    },
  },
  mounted() {
    this.initSysLogList()
  },
}
</script>

<style lang="stylus" scoped>
  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px
    
    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 搜索卡片
  .search-card
    background white
    border-radius 12px
    padding 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .search-header
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .search-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0 0 4px 0
    display flex
    align-items center
    gap 8px

  .search-subtitle
    color #6b7280
    font-size 14px
    margin 0

  .search-form
    /deep/ .el-form-item
      margin-bottom 16px
      
    /deep/ .el-form-item__label
      color #374151
      font-weight 500

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      transition all 0.3s ease
      
      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)

  .search-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 8px 16px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  .reset-btn
    border-radius 8px
    padding 8px 16px
    margin-left 8px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .header-left
    display flex
    align-items center
    gap 8px
    font-size 18px
    font-weight 600
    color #1f2937
    
    i
      color #667eea
      font-size 20px

  .header-right
    .el-tag
      border-radius 6px
      font-weight 500

  // 日志信息显示
  .log-info
    .info-row
      display flex
      align-items center
      margin-bottom 8px
      font-size 12px
      
      i
        color #667eea
        margin-right 6px
        font-size 14px
        width 14px
      
      .info-label
        color #6b7280
        margin-right 4px
        font-weight 500
        min-width 70px
      
      .info-value
        color #1f2937
        font-weight 500
        
        &.url-text
          color #667eea
          font-family monospace
          font-size 11px
        
        &.time-text
          color #059669
          font-family monospace
          font-size 11px
        
        &.body-text
          color #7c3aed
          font-family monospace
          font-size 11px
          background #f3f4f6
          padding 2px 6px
          border-radius 4px

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb
      
    td
      border-bottom 1px solid #f3f4f6
      
    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  /deep/ .el-tag
    border-radius 6px
    font-weight 500

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px
      
    .page-title-section
      padding 24px 20px
      
    .page-title
      font-size 24px
      
    .search-card, .table-card
      padding 16px
      
    .search-form
      /deep/ .el-form-item
        display block
        margin-bottom 12px
        
    .table-header
      flex-direction column
      gap 12px
      align-items flex-start
</style>
